import styled from 'styled-components/macro';
import { GREY_COLOR_8 } from 'shared/constants/colors';

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

export const Main = styled.div`
  max-width: 1400px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Btn = styled.p`
  background-color: ${GREY_COLOR_8};
  padding: 5px;
  border-radius: 4px;
  cursor: pointer;
`;

export const Text = styled.span`
  font-size: 16px;
  color: firebrick;
`;
